import React from 'react'
import ReactModal from 'react-modal'

import CrossIcon from '../../../assets/icons/cross.svg'
import { Message } from '../../utilites'
import LoaderLinear from "../../utilites/Loader/Loader";

const ConfirmModal = ({ isOpen, handleClose, handleAction, headerText, bodyText, error = '', loading = false, isNotTextContent = false }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel='Modal'
      className='modal-container'
      overlayClassName='modal-overlay'
      id='confirmModal'
    >
      <LoaderLinear isLoading={loading} />
      <div className='modal-header'>
        <h2>{headerText}</h2>
        <button
          className='button-icontrigger modal-closetrigger'
          onClick={handleClose}
          disabled={loading === true}
        >
            <span className='icon'>
                <CrossIcon />
            </span>
        </button>
      </div>
      <div className='modal-body'>
        {
          isNotTextContent
              ? bodyText
              : <p>{bodyText}</p>
        }
        {error && (<Message type='error' text={error} />)}
      </div>
      <div className='modal-footer contractAdd-modal-footer'>
        <button
          type='button'
          className={`button ${loading ? 'button-light' : ''}`}
          onClick={handleAction}
          disabled={loading === true}
        >
          Да
        </button>
        <button
          type='button'
          className='button-light'
          onClick={handleClose}
          disabled={loading === true}
        >
          Нет
        </button>
      </div>
    </ReactModal>
  )
}

export default ConfirmModal
